export const easeDefault = '0,0,.25,1'

export const DEV = import.meta.env.MODE === 'development'